import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { configureStore } from "./redux/store";
import { ErrorBoundary } from "react-error-boundary";
import { logApi } from "./utils/logger";
import AppError from "./views/app/error";

const App = React.lazy(() => import(/* webpackChunkName: "App" */ "./App"));
// const AppError = React.lazy(() =>
//   import(/* webpackChunkName: "App" */ "./views/app/error")
// );

const errorHandler = (error, info) => {
  console.log("Error --> ", error.message);
  console.log("Stack --> ", info.componentStack);
  logApi(error, info.componentStack);
};

ReactDOM.hydrate(
  <Provider store={configureStore()}>
    <Suspense fallback={<div className="loading" />}>
      <ErrorBoundary FallbackComponent={AppError} onError={errorHandler}>
        <App />
      </ErrorBoundary>
    </Suspense>
  </Provider>,
  document.getElementById("root")
);
/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister();
